import { gql } from '@apollo/client';

export const GET_SHIPMENT_TRACKING_COORDS = gql`
query GetTrackShipmentByIdWithLocationData($sessionId: String, $tripid: ID) {
  GetTrackShipmentByIdWithLocationData(sessionId: $sessionId, tripid: $tripid) {
    _id
    Unique_Id
    Vehicle_No
    Loading_Latitude
    Loading_Longitude
    Loading_Area
    Loading_By
    Loading_City
    Loading_Date
    Loading_Landmark
    Loading_Name
    Loading_Pincode
    Loading_Town
    Loading_Scope
    Loading_State
    Loading_Time
    Loading_Address_Line_1
    Unloading_Latitude
    Unloading_Longitude
    Unloading_Area
    Unloading_City
    Unloading_Landmark
    Unloading_Name
    Unloading_Pincode
    Unloading_Town
    Unloading_Scope
    Unloading_State
    Unloading_Address_Line_1
    tripId
    Driver_Number
    From_Location
    From_Type
    To_Location
    Consent_Status
    carrier
    consent_status
    Last_Location {
      City
      Name
      Pincode
      Town
      State
      Landmark
      latitude
      longitude
      address
      recorded_at
      total_distance
      time_remained
      distance_from_last_location
      Sequence_No
      eta
      Source
      PingNumber
    }
    To_Type
    Is_Live
    POD_Front_Copy
    POD_Back_Copy
    Load_Receipt_Copy
    Current_Stage
    LP_Business_Name
    KYC_Complete
    Is_Verified
    Expiry_Time
    Mobile_Number
    Reached_At_Loading_Point_Time
    Reached_At_Unloading_Point_Time
    Reached_At_Loading_Point
    Reached_At_Unloading_Point
    Location_Data {
      _id
      Unique_Id
      TrackTrip_ID
      Booking_ID
      consent_status
      Truck_Travel_Status
      Sim_History {
        City
        Name
        Pincode
        Town
        State
        Landmark
        latitude
        longitude
        address
        recorded_at
        total_distance
        time_remained
        distance_from_last_location
        Sequence_No
        eta
        Source
        PingNumber

      }
      FastTag_History {
        City
        Name
        Pincode
        Town
        State
        Landmark
        latitude
        longitude
        address
        recorded_at
        total_distance
        time_remained
        distance_from_last_location
        Sequence_No
        eta
        Source
        PingNumber
      }
      APP_History {
        City
        Name
        Pincode
        Town
        State
        Landmark
        latitude
        longitude
        address
        recorded_at
        total_distance
        time_remained
        distance_from_last_location
        Sequence_No
        eta
        Source
        PingNumber
      }
      Origin {
        City
        Name
        Pincode
        Town
        State
        Landmark
        latitude
        longitude
        address
        recorded_at
        total_distance
        time_remained
        distance_from_last_location
        Sequence_No
        eta
        Source
        PingNumber
      }
      Destination {
        City
        Name
        Pincode
        Town
        State
        Landmark
        latitude
        longitude
        address
        recorded_at
        total_distance
        time_remained
        distance_from_last_location
        Sequence_No
        eta
        Source
        PingNumber
      }
      Last_Known_Location {
        City
        Name
        Pincode
        Town
        State
        Landmark
        latitude
        longitude
        address
        recorded_at
        total_distance
        time_remained
        distance_from_last_location
        Sequence_No
        eta
        Source
        PingNumber
      }
      clustersDataFastTag_History
      clustersDataAPP_History
      clustersDataSim_History
      total_distance
      ata
      Is_Driver_Status
      Expiry_Time
      Is_Live
      createdAt
      updatedAt
    }
    Is_Driver_Status
    createdAt
    updatedAt
  }
}
`;
